// 主题配置文件
// 定义不同主题的结构和布局配置

export const themeConfigs = {
    'cacp-theme': {
        name: 'CACP layout',
        // 布局配置
        layout: {
            showHeader: true,
            showFooter: true,
            showTypeButtons: true,
            showVoiceInput: true,
            headerPosition: 'top', // 'top' | 'bottom'
            inputPosition: 'bottom', // 'top' | 'bottom'
        },
        // 结构配置
        structure: {
            // 是否显示用户标签
            showUserLabel: true,
            // 是否显示AI标签
            showAgentLabel: true,
            // 消息布局方式
            messageLayout: 'standard', // 'standard' | 'compact' | 'bubble'
            // 是否显示字符计数器
            showCharCounter: true,
            // 是否显示警告文本
            // showWarningText: true,
        },
        // 自定义类名
        customClasses: {
            modal: 'cacp-theme-modal',
            header: 'cacp-theme-header',
            content: 'cacp-theme-content',
            footer: 'cacp-theme-footer',
        }
    },
    'compact-theme': {
        name: 'compact layout',
        // 布局配置
        layout: {
            showHeader: true,
            showFooter: true,
            showTypeButtons: true,
            showVoiceInput: true,
            headerPosition: 'top',
            inputPosition: 'bottom',
        },
        // 结构配置
        structure: {
            // showUserLabel: false, // 不显示用户标签
            // showAgentLabel: true,
            messageLayout: 'standard', // 使用气泡布局
            showCharCounter: false, // 不显示字符计数器
            innerActionBtn: true,
            textareaRow: 2,
            simpleSubmitBtn: true,
            // showWarningText: false, // 不显示警告文本
        },
        // 自定义类名
        customClasses: {
            modal: 'compact-theme-modal',
            header: 'compact-theme-header',
            content: 'compact-theme-content',
            footer: 'compact-theme-footer',
        }
    }
};

// 获取主题配置
export const getThemeConfig = (theme = 'cacp-theme') => {
    return themeConfigs[theme] || themeConfigs['cacp-theme'];
};

// 合并自定义配置
export const mergeThemeConfig = (theme, customConfig = {}) => {
    const baseConfig = getThemeConfig(theme);
    return {
        ...baseConfig,
        layout: { ...baseConfig.layout, ...customConfig.layout },
        structure: { ...baseConfig.structure, ...customConfig.structure },
        customClasses: { ...baseConfig.customClasses, ...customConfig.customClasses },
    };
};
